<template>
  <form>
    <fieldset class="fieldset">
      <legend>{{ 'Filter'|t }}</legend>
      <div class="expanded row">
        <div class="column shrink">
          <label for="domain" class="text-right middle">{{ 'Domain'|t }}</label>
        </div>
        <div class="column">
          <input id="domain" placeholder="*" type="text" class="input-group-field text-center" v-model="filter.domain">
        </div>
        <div class="small-3 columns">
          <div class="expanded button-group">
            <button class="hollow success button" @click.prevent="submitForm()">{{ 'Submit'|t }}</button>
            <button class="hollow primary button" @click.prevent="clearForm()">{{ 'Clear'|t }}</button>
          </div>
        </div>
      </div>
      <a @click="toggleOpen"><i class="icon icon-equalizer2"></i> {{'Toggle filters'|t }}</a>
    </fieldset>

    <div class="callout expanded-filters" v-if="is_open">
      <fieldset class="fieldset">
        <legend>{{ 'Domain statuses'|t }}</legend>
        <div class="expanded row small-up-1 medium-up-2 large-up-5">
          <div class="column" v-for="s in getStatusList()" :key="s">
            <label>
              <input type="checkbox" v-model="filter.status" :value="s" /> {{ s }}
            </label>
          </div>
        </div>
      </fieldset>
      <fieldset class="fieldset">
        <legend>{{ 'Contacts'|t }}</legend>
        <div class="expanded row small-up-1 medium-up-2 large-up-4">
          <div class="column" v-for="c in getContactsList()" :key="c.field">
            {{ c.label|t }}
            <AutoCompleteContact v-model="filter[c.field]" :value="filter[c.field]"></AutoCompleteContact>
          </div>
        </div>
      </fieldset>
    </div>
  </form>
</template>
<script>
  import AutoCompleteContact from '@/components/AutoCompleteContact';

  export default {
    name: 'DomainCollectionFilterForm',
    components: { AutoCompleteContact },
    props: {
      value: {
        type: Object,
        default: () => {
          return {
            domain: "",
            status: [],
            registrant: "",
            admin: "",
            tech: "",
            billing: ""
          }
        }
      }
    },
    data() {
      return {
        filter: {
          domain: this.value.domain || "",
          status: this.value.status || [],
          registrant: this.value.registrant || "",
          admin: this.value.admin || "",
          tech: this.value.tech || "",
          billing: this.value.billing || ""
        },
        is_open: false
      }
    },
    methods: {
      submitForm() {
        this.$emit('submit', this.filter)
      },
      clearForm() {
        this.filter = {
          domain: "",
          status: [],
          registrant: "",
          admin: "",
          tech: "",
          billing: ""
        };
        this.is_open = false;
        this.$emit('reset', this.filter)
      },
      getStatusList() {
        return [
          'clientHold',
          'clientDeleteProhibited',
          'clientTransferProhibited',
          'clientUpdateProhibited',
          'clientRenewProhibited'
        ]
      },
      getContactsList() {
        return [
          { field: 'registrant', label: 'Registrant' },
          { field: 'admin', label: 'Admin' },
          { field: 'tech', label: 'Tech' },
          { field: 'billing', label: 'Billing' },
        ];
      },
      toggleOpen() {
        this.is_open = !this.is_open;
      }
    },
    watch: {
      watch: {
        filter: {
          deep: true,
          handler(to) {
            this.$emit('change', to)
          }
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/DomainCollectionFilterForm.vue